<template>
  <div>
    <img
      class="d-none d-sm-none d-md-none d-lg-none d-xl-inline-block"
      src="../assets/My-GDQ-Management.svg"
      width="400"
    />
    <img
      class="d-none d-sm-inline-block d-md-inline-block d-lg-inline-block d-xl-none"
      src="../assets/My-GDQ-Management.svg"
      width="340"
    />
    <img
      class="d-inline-block d-sm-none d-md-none d-lg-none"
      src="../assets/GDQ-White.svg"
      width="100"
    />
    &nbsp;
    <span
      v-if="gdqmodetext !== ''"
      class="badge gdq-mode-badge d-none d-sm-inline"
    >
      {{ gdqmodetext }}
    </span>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { config } from "../../config";

const gdqmodetext = ref(
  config.mode === "live" ? "" : config.mode === "stage" ? "TEST VUE3" : "DEV VUE3"
);
</script>

<style scoped>
.gdq-mode-badge {
  background-color: #ff0000;
  color: #ffffff;
}
</style>
